module.exports = __webpack_public_path__ + "img/new_logo.83f658a5.png";